import PropertyCompareTransitionWrapper from './property-compare-transition-wrapper'

export { PropertyCompareTransitionWrapper }

export default PropertyCompareTransitionWrapper
